import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import CalendarEventForm from 'containers/Forms/CalendarEvent';
import Modal from 'containers/Modals/Modal';
import Moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import User from '_class/User';
import swal from "sweetalert2";
import { stageConversation } from 'actions/conversation';
import { getSchedule } from 'actions/schedule';
import { PRESCHOOL } from 'constants/schoolTypes';
import { createExportAssessmentForSectionId } from "actions/assessments";
import SelectRecipient from 'containers/Conversation/Form/SelectRecipient';
import { Button } from '@haldor/ui';

var SectionTools = /*#__PURE__*/function (_Component) {
  _inherits(SectionTools, _Component);

  var _super = _createSuper(SectionTools);

  function SectionTools(props) {
    var _this;

    _classCallCheck(this, SectionTools);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "isUserOwner", function () {
      var _this$props = _this.props,
          currentUser = _this$props.currentUser,
          group = _this$props.group;

      if (currentUser == null || group == null) {
        return false;
      }

      var foundOwner = group.owners.find(function (owner) {
        return currentUser.id == owner.id;
      });

      if (foundOwner != null) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "onConversation", function () {
      _this.setState({
        selectRecipient: !_this.state.selectRecipient
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createAssessmentForSection", function () {
      swal.fire({
        title: _this.props.translate('export-assessment'),
        text: _this.props.translate('export-assessment-confirm-text'),
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: _this.props.translate('Cancel')
      }).then(function (result) {
        if (result.value != null) {
          _this.props.createExportAssessmentForSectionId(_this.props.group.id);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleForm", function (skip) {
      _this.setState({
        createEvent: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeForm", function (date) {
      _this.setState({
        createEvent: false
      });

      if (date != null) {
        _this.props.getSchedule(encodeURIComponent(Moment({
          hour: 0
        }).format('YYYY-MM-DD HH:mm:ss')), encodeURIComponent(Moment({
          hour: 23,
          minute: 59
        }).format('YYYY-MM-DD HH:mm:ss')));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectRecipientSubmit", function (conversation) {
      conversation.relationships.push({
        referenceType: 'SECTION',
        referenceId: _this.props.group.id,
        reference: _this.props.group
      });
      conversation.title = '';
      conversation.status = 'ACTIVE';
      conversation.id = 'new';
      conversation.messages = [];

      _this.props.stageConversation(conversation).then(function () {
        _this.setState({
          selectRecipient: false
        });

        _this.props.history.push("/conversations/new");
      });
    });

    _this.state = {
      createEvent: false
    };
    return _this;
  }

  _createClass(SectionTools, [{
    key: "render",
    value: function render() {
      var groupId = this.props.group.id;
      var user = new User(this.props.currentUser);
      var translate = this.props.translate;
      var isPreschool = false;

      if (this.props.currentUser.schools.getActiveSchool(this.props.currentUser.userId).type == PRESCHOOL) {
        isPreschool = true;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side"
      }, this.props.group.type != 'MENTOR_GROUP' && this.isUserOwner() ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.createEvent,
        onClose: this.closeForm,
        title: this.props.translate('create-lesson')
      }, /*#__PURE__*/React.createElement(CalendarEventForm, {
        onSubmit: this.closeForm,
        sectionId: this.props.group.id
      })) : null, /*#__PURE__*/React.createElement(Modal, {
        title: translate('send-message'),
        type: "small",
        isOpen: this.state.selectRecipient,
        onClose: this.onConversation
      }, /*#__PURE__*/React.createElement(SelectRecipient, {
        onSubmit: this.onSelectRecipientSubmit
      })), /*#__PURE__*/React.createElement("div", {
        className: "action-section",
        style: {
          marginBottom: '1.55rem'
        }
      }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('tools')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, !this.props.group.locked && this.isUserOwner() ? this.props.ArchiveButton(this.props.group) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, !this.props.group.locked && this.isUserOwner() ? this.props.EditButton(this.props.group) : null), !user.isStudent() && !isPreschool && this.props.group.type != 'MENTOR_GROUP' && !this.props.group.archived && this.props.services.schedule && this.isUserOwner() ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginTop: 5
        },
        onClick: this.toggleForm
      }, this.props.translate('create-lesson'))) : null, this.props.group.teamsUrl != '' && this.props.group.teamsUrl != null && this.props.group.locked == false ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        href: this.props.group.teamsUrl,
        style: {
          display: 'inline',
          marginBottom: 0
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary"
      }, this.props.translate('microsoft-teams')))) : null, this.props.group.type != 'MENTOR_GROUP' && this.isUserOwner() && !isPreschool ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/groups/".concat(groupId, "/basegroups"),
        style: {
          display: 'inline',
          marginBottom: 0
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary"
      }, this.props.translate('basegroups')))) : null));
    }
  }]);

  return SectionTools;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    services: state.Services.availableServices
  };
}

export default withRouter(connect(mapStateToProps, {
  stageConversation: stageConversation,
  createExportAssessmentForSectionId: createExportAssessmentForSectionId,
  getSchedule: getSchedule
})(SectionTools));